import {
  applyFilter,
  Button,
  closeJobModal,
  ComponentStyle,
  Form,
  Formik,
  FormikControl,
  InputError,
  moment,
  resetJobModal,
  setFilledDate,
  useRef,
  useState,
  useRouter,
  shouldRenderSuggestions,
  renderInputComponent,
  getUserSuggestionValue,
  renderUserSuggestion,
  onUserSuggestionsFetchRequested,
  onUserSuggestionsClearRequested,
  onUserSuggestionSelection,
  handleKeyDown,
  handleEmailDelete,
  Image,
  setQueryParams,
  PageStyle,
  ShowJobAction,
} from "@/imports-files/components/job-filters";
import Modal from "./common-modal/modal";
import { FormModalStyle } from "@/imports-files/components/review-email";

export function JobFilters(props) {
  const router = useRouter();
  const [startDate, setStartDate] = useState(router.query.start_date || null);
  const [endDate, setEndDate] = useState(router.query.end_date || null);
  const [location, setLocation] = useState(router.query.location || null);
  const selectDropdownRef = useRef(null);
  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const [agency_user_emails, setAgencyUserEmails] = useState(
    router.query.agency_user_emails
      ? Array.isArray(router.query.agency_user_emails)
        ? router.query.agency_user_emails
        : [router.query.agency_user_emails]
      : []
  );
  const [agency_user_initials, setAgencyUserInitials] = useState(
    setQueryParams(router)
  );
  const [agencyUserEmail, setAgencyUserEmail] = useState("");
  const [agencyUserError, setAgencyUserError] = useState("");
  const [users, setUsers] = useState([]);
  const formRef = useRef(null);
  const showJobAction = new ShowJobAction();
  const initialValues = {
    agency_user_emails: agency_user_emails,
    agency_user_initials: agency_user_initials,
  };

  return (
  <Modal
    type="form"
    heading="Filter"
    closeModal={(event) => {
      closeJobModal(event, props.setModal);
    }}
    content={
      <>
        <Formik initialValues={initialValues} innerRef={formRef}>
          {(formik) => (
            <Form>
              <div
                className={
                  FormModalStyle.Modal__Container__ContentSection__BlockContainer
                }
                style={{ gridTemplateColumns: "auto auto" }}
              >
                <div
                  className={
                    FormModalStyle.Modal__Container__ContentSection__Block
                  }
                >
                  <label
                    className={` ${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                  >
                    Date From
                  </label>
                  <FormikControl
                    control="customDatePicker"
                    className={"FilterCustomDateTime FilterCustomStartDate"}
                    format="DD/MM/yyyy"
                    inputProps={{
                      disabled: false,
                      placeholder: "Select Date",
                      readOnly: true,
                    }}
                    onChange={(value) => {
                      setStartDate(value);
                      document.querySelector(".filterEndDate").innerHTML = "";
                      document.querySelector(
                        ".FilterCustomEndDate input"
                      ).style.border = "1px solid #99ADBD";
                      if (
                        moment(value)
                          .startOf("day")
                          .isAfter(
                            setFilledDate(
                              document.querySelector(
                                ".FilterCustomEndDate input"
                              ).value
                            )
                          )
                      ) {
                        document.querySelector(".filterStartDate").innerHTML =
                          "Date from should be lesser than date to";
                        document.querySelector(
                          ".FilterCustomStartDate input"
                        ).style.border = "1px solid red";
                      } else {
                        document.querySelector(".filterStartDate").innerHTML =
                          "";
                        document.querySelector(
                          ".FilterCustomStartDate input"
                        ).style.border = "1px solid #99ADBD";
                      }
                    }}
                    reference={startDateRef}
                    value={
                      typeof startDate == "string"
                        ? setFilledDate(startDate)
                        : startDate
                    }
                  />
                  <label className="ErrorLabel filterStartDate"></label>
                </div>

                <div
                  className={
                    FormModalStyle.Modal__Container__ContentSection__Block
                  }
                >
                  <label
                    className={` ${FormModalStyle.Modal__Container__ContentSection__Block__Heading}`}
                  >
                    Date to
                  </label>
                  <FormikControl
                    control="customDatePicker"
                    className={"FilterCustomDateTime FilterCustomEndDate"}
                    format="DD/MM/yyyy"
                    inputProps={{
                      disabled: false,
                      placeholder: "Select Date",
                      readOnly: true,
                    }}
                    onChange={(value) => {
                      setEndDate(value);
                      document.querySelector(".filterStartDate").innerHTML =
                        "";
                      document.querySelector(
                        ".FilterCustomStartDate input"
                      ).style.border = "1px solid #99ADBD";

                      if (
                        moment(value)
                          .startOf("day")
                          .isBefore(
                            setFilledDate(
                              document.querySelector(
                                ".FilterCustomStartDate input"
                              ).value
                            )
                          )
                      ) {
                        document.querySelector(".filterEndDate").innerHTML =
                          "Date to should be greater than date from";
                        document.querySelector(
                          ".FilterCustomEndDate input"
                        ).style.border = "1px solid red";
                      } else {
                        document.querySelector(".filterEndDate").innerHTML =
                          "";
                        document.querySelector(
                          ".FilterCustomEndDate input"
                        ).style.border = "1px solid #99ADBD";
                      }
                    }}
                    reference={endDateRef}
                    value={
                      typeof endDate == "string"
                        ? setFilledDate(endDate)
                        : endDate
                    }
                  />
                  <label className="ErrorLabel filterEndDate"></label>
                </div>
              </div>
              <div
                className={
                  FormModalStyle.Modal__Container__ContentSection__Block
                }
              >
                <label
                  className={
                    FormModalStyle.Modal__Container__ContentSection__Block__Heading
                  }
                >
                  Location
                </label>
                <FormikControl
                  className={`${FormModalStyle.Form__Input} JobCustomSelect`}
                  control="select"
                  default={location}
                  disabled={(props?.job_locations?.length || 0) < 2}
                  onChange={(option) => {
                    option != null ? setLocation(option.value) : "";
                  }}
                  options={
                    showJobAction.get_json_data_for_location(
                      props.job_locations
                    )?.options
                  }
                  reference={selectDropdownRef}
                />
              </div>
              <div
                className={
                  FormModalStyle.Modal__Container__ContentSection__Block
                }
              >
                <label
                  className={
                    FormModalStyle.Modal__Container__ContentSection__Block__Heading
                  }
                >
                  Agency Users
                </label>
                <FormikControl
                  control="autosuggestInput"
                  errorClass={PageStyle.Form__Error}
                  formik={formik}
                  getSuggestionValue={getUserSuggestionValue}
                  inputProps={{
                    className: `AutosuggestOpenUp ${PageStyle.Form__Input} ${PageStyle.Form__textleft} ${PageStyle.Form__InputFullWidth}`,
                    formik: formik,
                    index: "ageny_user_email",
                    name: "agency_user_emails",
                    onChange: (value, { newValue, method }) => {
                      setAgencyUserEmail(newValue);
                      setAgencyUserError("");
                    },
                    placeholder: "Start typing name or work email",
                    style: InputError(formik, `agency_user_emails`),
                    value: agencyUserEmail,
                    onKeyDown: (event) =>
                      handleKeyDown(
                        event,
                        formik,
                        setAgencyUserEmail,
                        setAgencyUserError,
                        setAgencyUserEmails,
                        setAgencyUserInitials
                      ),
                    disabled: false,
                  }}
                  onChange={(value, { newValue, method }) => {
                    setAgencyUserEmail(newValue);
                  }}
                  onSuggestionsClearRequested={() =>
                    onUserSuggestionsClearRequested(setUsers)
                  }
                  onSuggestionsFetchRequested={(hash) => {
                    onUserSuggestionsFetchRequested(hash, setUsers);
                  }}
                  onSuggestionSelected={(event, { suggestion }) => {
                    if (suggestion.user_attributes.email.length > 0) {
                      setAgencyUserEmail("");
                      onUserSuggestionSelection(
                        formik,
                        agency_user_emails,
                        suggestion.user_attributes.email,
                        agency_user_initials,
                        {
                          email: suggestion.user_attributes.email,
                          name_initials:
                            suggestion.user_attributes.name_initials,
                          name: suggestion.user_attributes.name,
                          photo_url: suggestion.user_attributes.photo_url,
                        },
                        setAgencyUserEmails,
                        setAgencyUserInitials
                      );
                    }
                  }}
                  renderInputComponent={renderInputComponent}
                  renderSuggestion={renderUserSuggestion}
                  shouldRenderSuggestions={shouldRenderSuggestions}
                  suggestions={users}
                  type="text"
                />
                <div className={`${PageStyle.Tagrow} height110`}>
                  {agency_user_initials.map((item, index) => (
                    <div
                      className={`mt5 ${PageStyle.Tagrow__Tags}`}
                      key={`agency_user_${index}`}
                    >
                      {item?.photo_url ? (
                        <img
                          src={item?.photo_url}
                          className="JobImageSmall"
                        />
                      ) : (
                        item.name_initials && (
                          <div className={PageStyle.Tagrow__Prefix}>
                            {item.name_initials}
                          </div>
                        )
                      )}
                      {item.name ? (
                        <span>{item.name}</span>
                      ) : (
                        <span>{item.email}</span>
                      )}
                      <button
                        type="button"
                        className={PageStyle.Tagrow__Cancel}
                        onClick={() =>
                          handleEmailDelete(
                            formik,
                            index,
                            setAgencyUserEmails,
                            setAgencyUserInitials
                          )
                        }
                      >
                        <Close/>
                      </button>
                    </div>
                  ))}
                </div>
              </div>
            </Form>
          )}
        </Formik>
        <div className={FormModalStyle.Modal__Container__ButtonSection}>
          <Button
            buttonstyle={FormModalStyle.secondarybtn}
            onClick={() =>
              resetJobModal(
                props.setFiltersValue,
                props.setModal,
                props.setJobList,
                selectDropdownRef,
                startDateRef,
                endDateRef,
                setStartDate,
                setEndDate,
                setLocation,
                router,
                props.setApiError
              )
            }
          >
            Reset
          </Button>
          <Button
            buttonstyle={FormModalStyle.primarybtn}
            onClick={() =>
              applyFilter(
                props.setFiltersValue,
                props.setModal,
                props.setJobList,
                startDate,
                endDate,
                location,
                router,
                props.setApiError,
                agency_user_emails,
                agency_user_initials
              )
            }
          >
            Apply
          </Button>
        </div>
      </>
    }
  />
  );
}
